
import forEach from "lodash/forEach"
import get from "lodash/get"
import isEmpty from "lodash/isEmpty"
import moment, { Moment } from "moment"
import { Action } from "../../types/Action"
import { CHECK_FROM_PARAM, CHECK_READY, CLEAR_SEARCH, GET_SHIPS, HIDE_ATTEMPTS_MODAL, HIDE_CALENDAR_MODAL, HIDE_HISTORY_MODAL, HIDE_LAST_ROUND_RESULT, HIDE_STAT_MODAL, INIT, SEARCH_INPUT_CHANGE, SELECT_RATING_LEAGUE, SET_ERROR, SET_HISTORY_IS_FETCHING, SET_OFFLINE, SET_ONLINE, SET_PREPARE_STAGE_TAB, SET_SELECTED_CLAN_ID, SET_SELECTED_TAB, SET_USE_ATTEMPTS, SHOW_ATTEMPTS_MODAL, SHOW_CALENDAR_MODAL, SHOW_HISTORY_MODAL, SHOW_LAST_ROUND_RESULT, SHOW_NATION_SHIP_TYPE_STATISTIC, SHOW_STAT_MODAL, TOGGLE_AUTO_PARTICIPATION, TOGGLE_PLAYERS_COUNT_IN_RATING, WSS_ACTIONS } from "../Actions/ActionClanWars"

export const COMPETITION_METRIC = {
  EXP: 'exp',
  DAMAGE: 'damage',
  RIBBONS: 'ribbons_count'
}

export interface State {
  roundsHistoryCount: number,
  selectedStatType: any,
  selectedStatNation: null,
  ships: {
    [shipId: number]: Ship
  }
  hasErrors: boolean
  isFromPort: boolean
  isReady: boolean
  isOnline: boolean
  selectedTab: number
  prepageStageTabIndex: number
  isAttemptHistoryModalVisible: boolean
  selectedAttemptsUserId: string | null
  isStatModalVisible: boolean
  autoParticipation: boolean
  selectedStatisticNation: string | null
  selectedStatisticType: string | null
  allPlayersInRatingTable: boolean
  commonInfo: ICommonInfo
  stages: IStages
  warSettings: IWarSettings
  groupedBattles: any
  selectedClanRatingLeague: number | null
  searchInputValue: string
  clanRatingList: {
    data: Array<any>
    meta: any
  }
  clanRatingSearchList: {
    data: Array<any>
    meta: any
  }
  clanRatingAutocomplete: {
    data: Array<any>
    meta: any
  }
  selectedClanId: number | null
  commonInfoReady: boolean
  stageReady: boolean
  warSettingsReady: boolean
  isCalendarModalVisible: boolean
  isHistoryModalVisible: boolean
  restriction: null | number
  nextWeekStartDate: Moment,
  lastRoundResults: null | ILastRoundResults
  lastRoundResultsReady: boolean
  lastRoundResultsHidden: boolean
  useAttempts: boolean
  shipsLoaded: boolean
  roundsHistory: Array<IHistoryRound>
  isRoundsHistoryLoading: boolean
  roundsHistoryOffset: number,
  roundsHistoryLimit: number,
}

const TWO_DAYS_HOURS = 48

const getNextWeekStart = () => {

  const currentDayIndex = moment().day()

  let weekStartDate = moment().utcOffset(0).add(7 - currentDayIndex + 1, 'days')
  weekStartDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
  weekStartDate.toISOString()
  weekStartDate.format()

  return weekStartDate
}

const checklastRoundResultVisibility = (currentRound?: number) => {
  const round = currentRound ? currentRound : 0
  const localStorageDataString = localStorage.getItem(`clanWarsRound_${round}`)
  if (localStorageDataString) {
    const localStorageData = JSON.parse(localStorageDataString)
    if (localStorageData.lastRoundResultIsShows) {
      return true
    }
  }
  return false
}

const checkIfToLateToShowLastRound = (endDateStr: string) => {

  if (!endDateStr) {
    return false
  } else {
    const now = moment()
    const endDate = moment(endDateStr)
    const msDiff = now.diff(endDate)
    const hDiff = msDiff / 1000 / 60 / 60
    if (hDiff < TWO_DAYS_HOURS) {
      return false
    } else {
      return true
    }
  }
}


let initialState: State = {
  roundsHistoryCount: 0,
  selectedStatType: null,
  ships: {},
  hasErrors: false,
  isFromPort: false,
  isReady: false,
  isOnline: false,
  selectedTab: 0,
  prepageStageTabIndex: 0,
  isAttemptHistoryModalVisible: false,
  selectedAttemptsUserId: null,
  isStatModalVisible: false,
  autoParticipation: true,

  selectedStatisticNation: null,
  selectedStatisticType: null,
  allPlayersInRatingTable: false,

  commonInfo: {
    clan: {
      league: 1,
      maxStarsCount: 0,
      rating: 0,
      starsCount: 0,
      totalOilEarned: 0,
      roundsCount: 0,
      settings: {
        isParticipating: false,
        joinRoundAutomatically: false
      }
    },
    personal: {
      settings: {
        isAttemptsCount: false
      }
    }
  },

  stages: {
    currentStage: '',
    restrictions: [],
    war: {
      battles: [],
      personalAttemptsCount: 0,
      enemy: {
        color: '',
        league: 0,
        name: '',
        realm: '',
        starsCount: 0,
        tag: ''

      }
    },
    preparation: {
      clanProgress: 0,
      personalProgress: 0
    }
  },

  warSettings: {
    currentRound: 1,
    allowedBattleTypes: [],
    startDate: '',
    endDate: '',
    leagues: [],
    stages: {
      matchmaking: {
        endDate: '',
        startDate: ''
      },
      preparation: {
        clanProgressMilestones: [],
        startDate: '',
        endDate: '',
        maxClanProgress: 0,
        maxPersonalProgress: 0,
        personalProgressMilestones: [],
        competitionMetric: 'exp'
      },

      war: {
        startDate: '',
        endDate: '',
        grades: [],
        maxPersonalAttempts: 0,
        nations: [],
        // @ts-ignore
        rewards: [],
        classes: [],
        unavailableCells: [],
        topGradesIncrement: 0,
        rewardedStarsIncrement: 0,
        starsIncrementReward: {
          amount: 0,
          type: 'gold'
        },
        shipClasses: [],
        competitionMetric: 'exp'

      },
      rewarding: {
        roundResultRewards: {
          bigVictory: {
            type: 'oil',
            amount: 0
          },
          defeat: {
            type: 'oil',
            amount: 0
          },
          draw: {
            type: 'oil',
            amount: 0
          },
          victory: {
            type: 'oil',
            amount: 0
          }
        }
      }
    }
  },

  groupedBattles: {},
  selectedClanRatingLeague: 1,
  searchInputValue: '',
  clanRatingList: {
    data: [],
    meta: {}
  },
  clanRatingSearchList: {
    data: [],
    meta: {}
  },
  clanRatingAutocomplete: {
    data: [],
    meta: {}
  },
  selectedClanId: null,
  commonInfoReady: false,
  stageReady: false,
  warSettingsReady: false,
  isCalendarModalVisible: false,
  isHistoryModalVisible: false,
  restriction: null,
  nextWeekStartDate: getNextWeekStart(),
  lastRoundResults: null,
  lastRoundResultsReady: false,
  lastRoundResultsHidden: checklastRoundResultVisibility(),
  useAttempts: false,
  shipsLoaded: false,
  roundsHistory: [],
  isRoundsHistoryLoading: false,
  roundsHistoryOffset: 0,
  roundsHistoryLimit: 0,
}

const getResctrictionReason = restrictions => {

  let reason = null
  let isSet = false

  if (restrictions && restrictions.length > 0) {

    restrictions.forEach(item => {

      if (!isSet) {
        switch (item) {
          case 'ACCOUNT_NOT_IN_CLAN':
            {
              reason = 0
              isSet = true
              break
            }
          case 'CLAN_DOES_NOT_PARTICIPATE':
            {
              reason = 4
              isSet = true
              break
            }
          case 'ACCOUNT_MISSED_PREPARATION':
            {
              reason = 1
              break
            }
          case 'CLAN_MISSED_PREPARATION':
            {
              reason = 2
              isSet = true
              break
            }
          case 'CLAN_FAILED_PREPARATION':
            {
              reason = 3
              isSet = true
              break
            }

          default:
            {
              return
            }

        }
      } else {
        return
      }
    })
  }

  return reason
}

const mergeBattles = (stateBattles, newBattles) => {

  let battles = [...stateBattles, ...newBattles]

  let idsSet = new Set()

  // собираем массив завершенных боев
  battles.forEach(item => {
    if (item.finishedAt) {
      const selector = `${item.arenaId}_${item.clusterId}`
      idsSet.add(selector)
    }
  })

  // отфильтровываем незаконченные бои если они уже завершились
  battles = battles.filter(b => {

    if (b.finishedAt) {
      return true
    } else {
      const selector = `${b.arenaId}_${b.clusterId}`

      return !idsSet.has(selector)
    }

  })

  return battles
}

export type IReducerClanWars = (state: State, action: Action) => State
export const ReducerClanWars = (state: State = initialState, action: Action): State => {
  switch (action.type) {

    case SET_HISTORY_IS_FETCHING:
      {
        return {
          ...state,
          isRoundsHistoryLoading: action.payload.isFetching
        }
      }

    case WSS_ACTIONS.CWARS_UPDATE_ROUNDS_RESULTS_HISTORY:
      {
        const {
          items,
          count,
          offset,
          limit
        } = action.payload
        const newHistory = items.length ? items.reverse().map(round => {
          return {
            ...round,
            restriction: getResctrictionReason(round.restrictions)
          }
        }) : []

        const roundsHistory = newHistory
        console.log('roundsHistory', roundsHistory)
        return {
          ...state,
          roundsHistoryCount: count,
          roundsHistoryOffset: offset,
          roundsHistoryLimit: limit,
          roundsHistory: roundsHistory,
          isRoundsHistoryLoading: false
        }
      }

    case SHOW_HISTORY_MODAL:
      {
        return {
          ...state,
          isHistoryModalVisible: true
        }
      }
    case HIDE_HISTORY_MODAL:
      {
        return {
          ...state,
          isHistoryModalVisible: false,
          isRoundsHistoryLoading: false
        }
      }

    case GET_SHIPS:
      {
        return {
          ...state,
          ships: action.payload.ships,
          shipsLoaded: true
        }
      }

    case INIT:
      {
        return {
          ...state,
          hasErrors: false
        }
      }

    case SET_ERROR:
      {
        return {
          ...state,
          hasErrors: true
        }
      }

    case CHECK_FROM_PARAM:
      {
        return {
          ...state,
          isFromPort: action.payload.isFromPort
        }
      }

    case CHECK_READY:
      {
        return {
          ...state,
          isReady: action.payload.isReady
        }
      }

    case SET_USE_ATTEMPTS:
      {
        return {
          ...state,
          useAttempts: action.payload.val
        }
      }

    case HIDE_LAST_ROUND_RESULT:
      {
        return {
          ...state,
          lastRoundResultsHidden: true
        }
      }

    case SHOW_LAST_ROUND_RESULT:
      {
        return {
          ...state,
          lastRoundResultsHidden: false
        }
      }

    case SHOW_CALENDAR_MODAL:
      {
        return {
          ...state,
          isCalendarModalVisible: true
        }
      }
    case HIDE_CALENDAR_MODAL:
      {
        return {
          ...state,
          isCalendarModalVisible: false
        }
      }

    case CLEAR_SEARCH:
      {
        return {
          ...state,
          clanRatingSearchList: {
            data: [],
            meta: {}
          },
          clanRatingAutocomplete: {
            data: [],
            meta: {}
          },
          selectedClanId: null,
          searchInputValue: ''
        }
      }

    case SET_SELECTED_CLAN_ID:
      {
        return {
          ...state,
          selectedClanId: action.payload.clanId
        }
      }

    case SEARCH_INPUT_CHANGE:
      {

        let newState = {
          ...state,
          searchInputValue: action.payload.value
        }

        if (action.payload.value.length < 3) {

          newState = {
            ...newState,
            clanRatingSearchList: {
              data: [],
              meta: {}
            },
            clanRatingAutocomplete: {
              data: [],
              meta: {}
            },
            selectedClanId: null
          }
        }

        return newState
      }

    case SELECT_RATING_LEAGUE:
      {
        return {
          ...state,
          selectedClanRatingLeague: action.payload.league
        }
      }

    case TOGGLE_PLAYERS_COUNT_IN_RATING:
      {
        return {
          ...state,
          allPlayersInRatingTable: !state.allPlayersInRatingTable
        }
      }

    case WSS_ACTIONS.CWARS_UPDATE_LAST_ROUND_RESULTS:
      {

        const isTooLate = checkIfToLateToShowLastRound(action.payload.endDate)

        return {
          ...state,
          lastRoundResults: action.payload,
          lastRoundResultsReady: true,
          lastRoundResultsHidden: isTooLate ? isTooLate : state.lastRoundResultsHidden
        }
      }

    case WSS_ACTIONS.CWARS_UPDATE_RATINGS_SEARCH_AUTOCOMPLETE:
      {
        return {
          ...state,
          clanRatingAutocomplete: action.payload
        }
      }

    case WSS_ACTIONS.CWARS_UPDATE_RATINGS_SEARCH:
      {
        return {
          ...state,
          clanRatingSearchList: action.payload
        }
      }

    case WSS_ACTIONS.CWARS_UPDATE_RATINGS:
      {
        return {
          ...state,
          clanRatingList: action.payload,
          selectedClanRatingLeague: (action.payload.data && action.payload.data.length > 0) ? action.payload.data[0].league : state.selectedClanRatingLeague
        }
      }

    case WSS_ACTIONS.CWARS_UPDATE_COMMON_INFO:
      {

        let newState = {
          ...state,
          commonInfoReady: true,
          commonInfo: {
            clan: {
              ...state.commonInfo.clan,
              ...action.payload.clan,
              settings: {
                isParticipating: get(action.payload, 'clan.settings.isParticipating', state.commonInfo.clan.settings.isParticipating),
                joinRoundAutomatically: get(action.payload, 'clan.settings.joinRoundAutomatically', state.commonInfo.clan.settings.joinRoundAutomatically)
              }
            },
            personal: {
              settings: {
                isAttemptsCount: get(action.payload, 'personal.settings.isAttemptsCount', state.commonInfo.personal.settings.isAttemptsCount)
              }
            }
          }
        }

        const clanLeague = get(action.payload, 'clan.league', null)

        if (!state.selectedClanRatingLeague && clanLeague) {
          newState = {
            ...newState,
            selectedClanRatingLeague: clanLeague
          }
        }

        return newState
      }
    case WSS_ACTIONS.CWARS_UPDATE_STAGES:
      {

        if (isEmpty(action.payload)) {
          return {
            ...state,
            stageReady: true
          }
        }

        let groupedBattles = {}
        let battles = []

        if (!action.payload.stages.war.battles) {
          battles = state.stages.war.battles
        } else {
          let newBattles = action.payload.stages.war.battles.map(battle => {
            let ship = battle.shipCd && state.ships[battle.shipCd] || {}
            return {
              ...battle,
              ship: ship
            }
          })

          battles = mergeBattles(state.stages.war.battles, newBattles)
        }

        // группируем бои по нациям и классам кораблей
        forEach(battles, battle => {
          if (!groupedBattles[battle.nation]) groupedBattles[battle.nation] = {}

          if (!groupedBattles[battle.nation][battle.class]) groupedBattles[battle.nation][battle.class] = []

          groupedBattles[battle.nation][battle.class].push(battle)
        })

        return {
          ...state,
          groupedBattles,
          stageReady: true,
          restriction: getResctrictionReason(action.payload.restrictions),
          stages: {
            currentStage: action.payload.currentStage,
            restrictions: action.payload.restrictions,
            ...action.payload.stages,
            war: {
              ...state.stages.war,
              battles,
              enemy: {
                ...state.stages.war.enemy,
                ...action.payload.stages.war.enemy
              }
            },
            preparation: {
              ...state.stages.preparation,
              ...action.payload.stages.preparation
            }
          }
        }
      }
    case WSS_ACTIONS.CWARS_UPDATE_SETTINGS:
      {

        const lastRoundResultsHidden = checklastRoundResultVisibility(action.payload.currentRound)

        return {
          ...state,
          warSettingsReady: true,
          lastRoundResultsHidden: lastRoundResultsHidden,
          warSettings: {
            ...action.payload
          }
        }
      }
    case SET_ONLINE:
      {
        return {
          ...state,
          isOnline: true
        }
      }
    case SET_OFFLINE:
      {
        return {
          ...state,
          isOnline: false
        }
      }
    case SHOW_NATION_SHIP_TYPE_STATISTIC:
      {
        return {
          ...state,
          isStatModalVisible: true,
          selectedStatisticNation: action.payload.nation,
          selectedStatisticType: action.payload.type
        }
      }
    case TOGGLE_AUTO_PARTICIPATION:
      {
        return {
          ...state,
          autoParticipation: !state.autoParticipation
        }
      }
    case SHOW_STAT_MODAL:
      {
        return {
          ...state,
          isStatModalVisible: true
        }
      }
    case HIDE_STAT_MODAL:
      {
        return {
          ...state,
          isStatModalVisible: false,
          selectedStatNation: null,
          selectedStatType: null
        }
      }
    case SHOW_ATTEMPTS_MODAL:
      {
        return {
          ...state,
          isAttemptHistoryModalVisible: true,
          selectedAttemptsUserId: action.payload.id
        }
      }
    case HIDE_ATTEMPTS_MODAL:
      {
        return {
          ...state,
          isAttemptHistoryModalVisible: false,
          selectedAttemptsUserId: null
        }
      }
    case SET_SELECTED_TAB:
      {
        return {
          ...state,
          selectedTab: action.payload.selectedTab
        }
      }
    case SET_PREPARE_STAGE_TAB:
      {
        return {
          ...state,
          prepageStageTabIndex: action.payload.prepageStageTabIndex
        }
      }
    default:
      return state

  }
}